export default "__VITE_ASSET__BcwyprpL__"